import { render } from "./MetadataPage.vue?vue&type=template&id=149f0164"
import script from "./MetadataPage.vue?vue&type=script&lang=js"
export * from "./MetadataPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/fep.theismailiusa.org/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__